export default __webpack_public_path__ + "static/media/header-sticky-m.aadf903a.png";